import axios from 'axios';
import incoterm from './incoterm';
// initial state
// shape: [{ id, quantity }]
const state = () => ({
    list : [],
    steps: [],
    take : 25,
    columns: [
            {
                key : "name",
                label : "Name",
                setable: false,
                class: "is-2",
                display : true
            },
            {
                key : "description",
                label : "Description",
                display : true
            },
        ],
    loaded : false,
    loadingMore: false,
    loading: false,
    allLoaded : false,
    addNew : false,
    workingOn: [],
    version : 1,
})

  // getters
  const getters = {
      isWorkingOn : (state) => (id) => {
          var index = state.workingOn.findIndex(id);
          if(index >= 0){
              return true;
          }else{
              return false;
          }
      }
  }

  // actions
  const actions = {
    async load({commit, state, rootState}){
        commit("isLoading", true);
        if(state.allLoaded == false){
            await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/logistic_block", {params: {take: state.take, skip:state.list.length, version: state.version}}).then((response) => {
                commit("setList", response.data.data);
                commit("incoterm/set", response.data.meta.incoterms);
                commit("incoterm/loadingStatus", false);

                commit("isLoading", false);
            })
        }
        commit("isLoading", false);
    },
    async loadFiltered({commit, state, rootState}, data){
        let take = 25;
        return await axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/logistic_block",
            {
                params:
                {
                    search: data.search,
                    take: take,
                    skip: data.skip,
                    version: data.version
                }
            });
    },
    loadUserAddables({commit, state, rootState}, data = {
        take: 25,
        skip : 0,
        search: "",
        version: 0,
    }){
        let take = 25;
            return axios.get(rootState.settings.url + "/api/v1/"+rootState.settings.internal.user_company +"/logistic_block",
                {
                    params:{
                        user_addable : true,
                        take: take,
                        skip: data.skip,
                        search: data.search,
                        version: data.version,
                    }
                    })
    }
  }

  // mutations
  const mutations = {
      subLoading(state, mail){
          var index = state.workingOn.findIndex(item => item = mail.id);
          if(index >= 0){
              state.workingOn.splice(index, 1);
          }else{
              state.workingOn.push(mail.id);
          }
      },
      setList(state, list){
          if(list == undefined || list.length <= 0){
            state.allLoaded = true;
          }
          state.list.push(...list);
      },
      setSteps(state, list){
        if(list == undefined || list.length <= 0){
          state.allLoaded = true;
        }
        state.steps.push(...list);
    },
      increasePage(state){
          state.loadingMore = true;
          state.page++;
      },
      isLoading(state, status){
          state.loadingMore = status;
          state.loading = status;
      },
      clean(state){
        state.loading = false;
        state.loadingMore = false;
        state.allLoaded = false;
        state.list = [];
      },
      setVersion(state, version){
        state.version = version;
      }
  }

  export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {
        incoterm,
    }
  }
